<template>
  <div>
    <div v-if="exercisesInfo.length>0">
      <a-collapse class="collapse" :expand-icon-position="expandIconPosition" accordion v-model="activeKey">
        <a-collapse-panel v-for="(item, inx) in exercisesInfo" :key="inx">
          <div slot="header">
            <div class="classImages">
              <span class="iconfont class-list-grey" v-if="item.status == 2">已过期</span>
              <img :src="item.photo" alt="" />
            </div>
            <div class="moudle-header-right">
              <div class="moudle-header-right-title">
                {{ item.name }}
              </div>
              <div class="moudle-header-right-content">
                {{ item.abstract }}
              </div>
            </div>
          </div>
          <ul class="ulChapter">
            <li class="chapter" v-for="(chapter,index) in item.chapter" :key="chapter.chapter_id">
              <span class="order">第{{ index+1 }}章</span>
              <span class="chapterName">{{ chapter.name }}</span>
              <div class="now-btn" @click="startPractice(item.id,chapter)" v-if="item.status == 1">立即练习</div>
            </li>
          </ul>
        </a-collapse-panel>
      </a-collapse>
      <div class="pages" v-if="this.exercisesInfo.length > 0">
        <a-pagination :defaultPageSize="3" @change="onChange" :locale="zhCN" :default-current="1" :total="this.num" />
      </div>
    </div>
    <div class="noData-box" v-else>
      <img src="@/assets/empty.png" alt="">
      <div class="text">暂无相关内容</div>
    </div>

  </div>
</template>

<script>
import zhCN from "ant-design-vue/es/locale-provider/zh_CN";
import services from "../../../config/services";
import { mapState } from "vuex";
export default {
  name: "myPractice",
  components: {},
  data () {
    return {
      services: services,
      activeKey: [],
      exercisesInfo: [], //练习列表
      exe_id: "",//当前练习id
      chapter: "",//当前章
      num: 0,
      zhCN,
      expandIconPosition: "right",
      card: "",
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.appsLogin.appsUserInfo,
    })
  },
  mounted () {
    this.lodData({
      page: 1,
      size: 3,
    });
  },
  watch: {
    activeKey (key) {
      if (key && !this.exercisesInfo[key].chapter) {
        services.getUserExercisesDetails({
          // is_abstract: 1,
          id: this.exercisesInfo[key].id
        }).then((res) => {
          if (res.code === "0000") {
            this.$set(this.exercisesInfo[key], "chapter", res.data.chapter);
          }
        });
      }
    },
  },
  methods: {
    //加载数据
    lodData (params) {
      //let that =this;
      services.getUserExercisesList({
        ...params,
      }).then((res) => {
        if (res.code === "0000") {
          this.exercisesInfo = res.data.items;
          this.num = res.data.total;
          // this.exercisesInfo.forEach(function (item) {
          //   item.photo = item.photo.replace("/app", `${services.IMG_SERVER}/app`);
          // })
        }
      });
    },
    //获取用户答题卡
    cardData (params) {
      services.getUserExercisesCard({
        ...params,
        is_again: 2,
      }).then((res) => {
        if (res.code === "0000") {
          this.card = res.data;
          // 是否提交过1是2否
          if (res.data.is_sub == "1") {
            this.$router.push({
              path: `/${this.userInfo.school_code}/user/myPractice/AgainPractice`,
              query: {
                chapter_id: this.chapter.id,
                name: this.chapter.name,
                exe_id: this.exe_id,
              }
            });
          } else {
            this.$router.push({
              path: `/${this.userInfo.school_code}/user/myPractice/NowPractice`,
              query: {
                chapter_id: this.chapter.id,
                name: this.chapter.name,
                exe_id: this.exe_id
              }
            });
          }
        } else {
          this.$message.info(res.message ? res.message : '获取失败')
        }
      })
    },
    //立即练习
    startPractice (exe_id, chapter) {
      this.cardData({
        exe_id: parseInt(exe_id),
        chapter_id: parseInt(chapter.id),
      });
      this.exe_id = exe_id;
      this.chapter = chapter
    },

    onChange (pageNumber) {
      this.lodData({
        page: pageNumber,
        size: 3,
      });
    },
  },
};
</script>

<style scoped lang="less">
img {
  width: 240px;
  height: 150px;
  float: left;
}
.moudle-header-right {
  float: left;
  margin-left: 18px;
  width: 60%;
}
.moudle-header-right-title {
  height: 32px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #14202c;
  line-height: 32px;
}
.moudle-header-right-content {
  margin-top: 45;
  height: 60px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #969696;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
ul li {
  list-style: none;
}
.moudle-test {
  margin-top: 30px;
  margin-left: 22px;
}
.chapter {
  font-size: 14px;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e4e4e4;
}
.moudle-button {
  position: fixed;
  bottom: 84px;
  right: 50px;
}
.collapse-title {
  flex: 1 0 90%;
  order: 1;
}
/deep/.ant-collapse-header {
  height: 150px;
}
.chapterName {
  margin-left: 20px;
}
.ulChapter {
  margin-left: 20px;
  margin-bottom: 20px;
}
/deep/.ant-collapse-content > .ant-collapse-content-box {
  padding: 0px;
  width: 97%;
}
/deep/.ant-collapse-content {
  border-top: none;
}
.ulChapter .now-btn {
  float: right;
  border-radius: 16px;
  width: 90px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin-top: 5px;
  background-color: #2462f5;
  cursor: pointer;
}
.ant-collapse {
  background-color: #fff;
}
.collapse > div {
  width: 93%;
}
.ant-collapse > .ant-collapse-item {
  border-bottom: 10px solid #f1f5ff;
  margin-left: 35px;
  margin-top: 35px;
}
.ant-collapse {
  border: none;
}
/deep/.ant-collapse-icon-position-right
  > .ant-collapse-item
  > .ant-collapse-header {
  padding: 0px;
}
.classImages {
  height: 150px;
  width: 240px;
  float: left;
}
.classImages .class-list-grey {
  position: absolute;
  left: 0;
  background: #363d50;
  color: #fff;
  border-radius: 0 0 8px 0;
  font-size: 12px;
  padding: 4px 16px;
}
.order,
.chapterName {
  color: #333333;
}
.pages {
  margin-bottom: 20px;
  margin-top: 20px;
}

.noData-box {
  width: 100%;
  text-align: center;
  height: 770px;
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 150px;
  img {
    width: 240px;
    height: auto;
    margin: 0 auto 30px;
  }
  .text {
    color: #76797e;
    font-size: 14px;
  }
}
</style>